<template>
  <v-container v-if="loaded">
    <h1 class="display-3">Тесты</h1>
    <v-simple-table v-if="tests.length">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-right">N</th>
            <th class="text-left">Название</th>
            <th class="text-right">Количество результатов</th>
            <th class="text-right">Средний результат</th>
            <th class="text-right">Лучший результат</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(test, index) in tests" :key="test.name">
            <td class="text-right">{{ index + 1 }}</td>
            <td>
              <router-link :to="{ name: 'test', params: { id: test.id } }">
                {{ test.name }}
              </router-link>
            </td>
            <template v-if="test.count">
              <td class="text-right">{{ test.count }}</td>
              <td class="text-right">
                {{ test.avg | score }} / {{ test.size }}
              </td>
              <td class="text-right">{{ test.max }} / {{ test.size }}</td>
            </template>
            <template v-else>
              <td class="text-right">-</td>
              <td class="text-right">-</td>
              <td class="text-right">-</td>
            </template>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <p v-else>Тесты еще не готовы. Зайдите позже.</p>
  </v-container>
  <v-container v-else>
    <v-skeleton-loader
      class="mt-4"
      loading
      tile
      type="heading, table-tbody"
    ></v-skeleton-loader>
  </v-container>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  name: 'Tests',
  data() {
    return {
      tests: [],
      loaded: false
    }
  },
  mounted() {
    this.request('api/tests').then(({ data }) => {
      this.tests = data
      this.loaded = true
    })
    this.request('session/active').then(({ data }) => {
      if (Array.isArray(data) && data[0]) {
        this.$router.push({
          name: 'session',
          params: { id: data[0].session.id }
        })
      }
      this.loaded = true
    })
  },
  methods: {
    ...mapActions(['request'])
  }
}
</script>
